import { TableCell, TableRow } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

interface Props {
  rows: number;
}

export default function RowsLoader(props: Props) {
  return (
    <>
      {Array.from(Array(props.rows).keys()).map(key => (
        <TableRow key={key}>
          <TableCell align="left">
            <Skeleton variant="text" animation="wave" />
          </TableCell>
          <TableCell align="left">
            <Skeleton variant="text" animation="wave" />
          </TableCell>
          <TableCell align="left">
            <Skeleton variant="text" animation="wave" />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}
